import * as React from 'react';

import './src/@lekoarts/gatsby-theme-cara/styles/main.scss';

export function wrapPageElement({ element, props }) {
	return <div>{element} </div>;
}
